import { apiCall } from "./api";

const URL = "/api/v1/manage-dashboard";

export const getDashboardVersion = () => {
  return apiCall(
    URL + "/version-manage",
    {
      method: "GET",
      credentials: "include",
    },
    "APP_VERSION",
  );
};

export const updateDashboardVersion = (data) => {
  return apiCall(`${URL}/version`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(data),
  });
};
